import {
  fetchClient
} from "./chunk-K342ITN7.mjs";
import {
  ApiConfig
} from "./chunk-LPIRJEMY.mjs";
import {
  __async,
  __spreadProps,
  __spreadValues
} from "./chunk-DFMI36TU.mjs";

// src/core/wbk/booking/generatedPayment.ts
import { getLocaleOnly } from "@wbk/utils";
import { Exception } from "@wbk/logger";
var getGeneratedPayment = (_0) => __async(void 0, [_0], function* ({ id, lang = "en", type = "waiting" }) {
  var _a, _b, _c, _d, _e, _f;
  try {
    const locale = getLocaleOnly(lang);
    const redirect = `${(_b = (_a = ApiConfig.config) == null ? void 0 : _a.wbk) == null ? void 0 : _b.ticketingDomain}/${lang}/payment-success`;
    const redirect_failed = `${(_d = (_c = ApiConfig.config) == null ? void 0 : _c.wbk) == null ? void 0 : _d.ticketingDomain}/${lang}/payment-failed`;
    const url = type === "bundle" ? "bundles/proceed-waiting-payment" : type === "upgrade" ? "/proceed-upgrade-payment" : "/formula1/proceed-waiting-payment";
    const data = yield fetchClient({
      url: `${url}/${id}?lang=${locale}`,
      options: {
        method: "POST",
        body: JSON.stringify({
          locale,
          lang: locale,
          redirect,
          redirect_failed,
          booking_source: (_f = (_e = ApiConfig.config) == null ? void 0 : _e.wbk) == null ? void 0 : _f.appSource
        })
      }
    });
    if (data.summaries) {
      return __spreadProps(__spreadValues({}, data.data), {
        summaries: data.summaries
      });
    }
    return data.data;
  } catch (error) {
    throw new Exception({
      error,
      name: "getGeneratedPaymentException",
      context: { extra: { id, type }, tags: { journey: "checkout" } }
    });
  }
});

export {
  getGeneratedPayment
};
//# sourceMappingURL=chunk-AQAOX4IV.mjs.map